// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3918":"cea4ad92","4282":"f1d738d4","7670":"e1e08c29"}[chunkId] + ".chunk.css";
};